import { IAlertProps } from "@components/alert/Alert.types";
import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { ISmartFastEntriesActionEvent } from "@components/smart/smartFastEntryList";
import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrCaregivingEventEntity, IPrLongTermCaregivingEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import CaregivingEndEventDialog from "@pages/payroll/socialEvents/CaregivingEndEventDialog";
import {
    careGivingDetailTypeBeforeSave,
    defaultCareIntervalsAfterLoad,
    handleDurationIntervalLineItemsAction,
    handleDurationIntervalLineItemsChange,
    handleDurationIntervalToggle,
    initMonthDetailsAfterLoad
} from "@pages/payroll/socialEvents/SocialEvents.utils";
import { SocialEventsFormViewForExtend } from "@pages/payroll/socialEvents/SocialEventsFormView";
import React from "react";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class LongtermCaregivingAllowanceFormView extends SocialEventsFormViewForExtend<IPrLongTermCaregivingEventEntity> {
    typeCode = PrSocialEventTypeCode.LongtermCaregivingAllowance;

    async onAfterLoad(): Promise<void> {
        const { storage } = this.props;
        defaultCareIntervalsAfterLoad(storage);
        initMonthDetailsAfterLoad(this.props.storage);
        return super.onAfterLoad();
    }

    handleChange = (e: ISmartFieldChange): void => {
        const { storage } = this.props;
        handleDurationIntervalToggle(storage, e);

        super.handleChange(e);
        // keep after calling parent method, so change is applied to storage before handling the dependencies
    }

    handleLineItemsAction(args: ISmartFastEntriesActionEvent): void {
        handleDurationIntervalLineItemsAction(this.props.storage, args);
        super.handleLineItemsAction(args);
    }

    async handleLineItemsChange(args: ISmartFieldChange): Promise<void> {
        handleDurationIntervalLineItemsChange(this.props.storage, args);
        return super.handleLineItemsChange(args);
    }

    onBeforeSave(): IPrCaregivingEventEntity {
        const entity = super.onBeforeSave();
        return careGivingDetailTypeBeforeSave(entity);
    }

    renderEventEndDialog(endDialogAlert: IAlertProps): React.ReactElement {
        return (
            <CaregivingEndEventDialog storage={this.props.storage}
                                      alert={endDialogAlert}
                                      title={this.props.storage.t("SocialEvents:Form.EndEventDialogTitle")}
                                      onClose={this.handleCloseEventEndDialog}/>
        );
    }

    renderButtons(): React.ReactElement {
        return this.renderSocialEventButtons();
    }
}

export default withPermissionContext(withConfirmationDialog(LongtermCaregivingAllowanceFormView));